const Board = () => import('@/views/Board.vue');
const JBoard = () => import('@/views/JBoard.vue');
const CallBack = () => import('@/views/CallBack.vue');


import store from '@/store';
import conf from'@/config/config';
const LoginUrl = conf.loginurl;

const routes = [
  {
    path: '/',
    name: 'JBoard',
    component: JBoard,
  },
  {
    path: '/board',
    name: 'Board',
    component: Board,
  },
  {
    path: '/callback',
    name: 'CallBack',
    component: CallBack,
    meta: {
      title: "callback login"
    },
    beforeEnter(to, from, next) {
      store.dispatch('fetchUser');
      store.dispatch('fetchReturnUrl');
      if (!store.state.user) {
        next();
      }else{
        next('/');
      }
    }
  }
];

export default routes;
